<template>
	<gmap-map
      :center="center"
      :zoom="12"
      style="width:100%; height: 100%;">
	    <gmap-marker
	        :position="center"
	        @click="infoWinOpen=true"
	      ></gmap-marker>

	      <gmap-info-window 
	      	:options="infoOptions" 
	      	:position="center" 
	      	:opened="infoWinOpen"

	      	@closeclick="infoWinOpen=false">
	      	<!--<slot></slot>-->

	      </gmap-info-window>
      <!--</gmap-info-window>-->
    </gmap-map>
</template>
<script>

	import * as VueGoogleMaps from "vue2-google-maps";

	Vue.use(VueGoogleMaps);

    export default {
    	name: 'ContactMap',
    	componentName: 'contact-map',
    	props: [
    		'center',
		    'content'
    	],
    	data(){
    		return{
    			infoWinOpen: true,
    			infoOptions: {
		        	pixelOffset: {
		        		width: 0,
		       			height: -35
		        	},
				    content:this.content,
		        }
    		}
    	},
        mounted() {
            let gMapsApiKey = window.App.gmapsApiKey;
        	if( gMapsApiKey && !VueGoogleMaps.isApiSetUp ){
	        	VueGoogleMaps.loadGmapApi({
	        		key: gMapsApiKey
	        	});
        	}
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/ContactMap.vue